import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {UrlParams} from "./url-params-serializer";
import {HttpDownloadService} from "./http-download.service";

/**
 * This class toggles child element based on a setting (boolean evaluation).
 * It subscribes to AppSettingsService.
 * Based on [ngIf]: https://github.com/angular/angular/blob/2.2.x/modules/%40angular/common/src/directives/ng_if.ts
 */
@Directive({
  selector: "[downloadFile]",
})
export class HttpDownloadDirective {
  private _url: string;
  private _params: UrlParams;

  @Input()
  get downloadFile(): string {
    return this._url;
  }

  set downloadFile(v: string) {
    this._url = v;
    this.rebuildHref();
  }

  @Input()
  get params(): UrlParams {
    return this._params;
  }

  set params(v: UrlParams) {
    this._params = v;
    this.rebuildHref();
  }

  @Input()
  stopPropagation: boolean;

  private rebuildHref(): void {
    if (this.el.nativeElement.tagName === "A") {
      this.el.nativeElement.href = "javascript:void(0)"; // eslint-disable-line no-script-url
    }
  }

  constructor(
    private el: ElementRef,
    private httpDownloadService: HttpDownloadService,
  ) {
  }

  @HostListener("click", ["$event"])
  click(event: Event) {
    event.preventDefault();

    this.httpDownloadService.downloadXHR(this._url, this._params);

    if (this.stopPropagation) {
      event.stopPropagation();
    }

    return false;
  }
}
